import { getAllTransferOrders, getAllWarehouseStock, getDispatchOrderByWarehouse, getDispatchOrderRowsById, getFullfillmentOrderRows, getFullfillmentOrders, getTransferOrderById, getTransferOrderReferenceData, getTransferProducts, getWarehouseById, getWarehouseLocationsById, getWarehouseStockById, getWarehouses } from "src/utils/apiRequests";
import useResponse, { useResponseLegacy } from "../useResponse";
import useGetAllPaginatedItemsLegacy from "../useGetAllPaginatedItems";

export const useGetWarehouseById = (id: string) => {
    const [response] = useResponseLegacy<any[]>(getWarehouseById, { id }, true);
    return response;
}
export const useGetWarehouseLocationsById = (id: string) => {
    const [response] = useResponseLegacy<any[]>(getWarehouseLocationsById, { id }, true);
    return response;
}
export const useGetWarehouseStockById = (id: string | string[]) => {
    return useGetAllPaginatedItemsLegacy<any>(getWarehouseStockById, 1000, "ArticleNumber", id);
};

export const useGetDispatchOrdersByWarehouse = (warehouseId: string | string[]) => {
    const response = useGetAllPaginatedItemsLegacy<any>(getDispatchOrderByWarehouse, 500, "DispatchOrderId", warehouseId);
    return response;
};
export const useGetDispatchOrdersRowsByWarehouse = (warehouseId: string, orderId) => {
    const [response] = useResponseLegacy<any[]>(getDispatchOrderRowsById, { warehouseId,orderId }, true);
    return response;
}



export const useGetAllWarehouseStock = () => {
    return useGetAllPaginatedItemsLegacy<any>(getAllWarehouseStock, 1000, "ArticleNumber");

}
export const useGetWarehouses = () => {
    const [response] = useResponseLegacy<any[]>(getWarehouses);
    return response;
}
export const useGetFullfillmentOrders = (shouldRequest = true) => {
    
    const response =  useGetAllPaginatedItemsLegacy<any[]>(getFullfillmentOrders, 1000, "Id", null, shouldRequest);
    return response;
}
export const useGetFullfillmentOrderRows = (id, dependency) => {
    
    const [response] = useResponseLegacy<any>(getFullfillmentOrderRows, { id }, true, dependency);
    return response;
}




export const useGetAllTransferOrders = () => {
    return useGetAllPaginatedItemsLegacy<any>(getAllTransferOrders, 500, "OrderId");

}
export const useLatestTransferOrders = (amount = 5) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getAllTransferOrders,values:{amount,pageSize:1}, requestNothingOnNull:true});
    return result;
}
export const useGetTransferOrderById = (id: string, dependecy?) => {
    const [response] = useResponseLegacy<any>(getTransferOrderById, { id }, true,dependecy);
    return response;
}
export const useTransferOrderReferenceData = () => {
    return useResponseLegacy<any>(getTransferOrderReferenceData);
}

export const useGetTransferProducts = (warehouseId) => {
    const response =  useGetAllPaginatedItemsLegacy(getTransferProducts,500, "ProductId", warehouseId, !(warehouseId == null));
    return response;
}

